import { getShipmentsThunk } from '@redux/features/shipment.slice';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import BreadCrumb from 'Common/BreadCrumb';
import React, { FC, useEffect, useState } from 'react';
import UpdateShipmentModal from './UpdateShipmentModal';
import ButtonBase from 'components/ui/buttons/ButtonBase';

const Shipments: FC = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { shipments, loading } = useAppSelector((state: RootState) => state.shipmentState);

    useEffect(() => {
        dispatch(getShipmentsThunk());
    }, [dispatch]);

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(value);
    };

    return (
        <>
            <UpdateShipmentModal show={showModal} handleClose={handleCloseModal} shipment={shipments} />
            <BreadCrumb pageTitle={`Shipments`} />
            <section className="py-5">
                <div className="p-3 flex flex-col gap-2 bg-[#fff]">
                    <div className="flex w-full items-center justify-between">
                        <h3 className="font-extrabold text-[#bd902e]">Shipments</h3>
                        <ButtonBase
                            innerText="Update Shipment"
                            onClick={handleOpenModal}
                            disabled={loading || !shipments}
                        />
                    </div>
                    {loading ? (
                        <>
                            <div className="mx-auto flex my-6 items-center justify-center rounded-md bg-white">
                                <div className="size-10 animate-spin rounded-full border-4 border-custom-500 border-l-transparent" />
                            </div>
                        </>
                    ) : shipments && shipments.id ? (
                        <>
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                                <div className="card border-custom-200 bg-custom-100 dark:border-custom-600 dark:bg-custom-400/20">
                                    <div className="card-body">
                                        <h6 className="mb-4 text-15 text-custom-500 dark:text-custom-200">
                                            Shipment ID
                                        </h6>
                                        <p className="mb-4 text-2xl font-bold text-custom-600 dark:text-custom-300">
                                            #{shipments.id}
                                        </p>
                                    </div>
                                </div>
                                <div className="card border-green-200 bg-green-100 dark:border-green-600 dark:bg-green-400/20">
                                    <div className="card-body">
                                        <h6 className="mb-4 text-15 text-green-500 dark:text-green-200">Balance</h6>
                                        <p className="mb-4 text-2xl font-bold text-green-600 dark:text-green-300">
                                            {formatCurrency(shipments.balance)}
                                        </p>
                                    </div>
                                </div>
                                <div className="card border-blue-200 bg-blue-100 dark:border-blue-600 dark:bg-blue-400/20">
                                    <div className="card-body">
                                        <h6 className="mb-4 text-15 text-blue-500 dark:text-blue-200">Last Cost</h6>
                                        <p className="mb-4 text-2xl font-bold text-blue-600 dark:text-blue-300">
                                            {formatCurrency(shipments.lastCost)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-10 text-gray-500">No shipment data available</div>
                    )}
                </div>
            </section>
        </>
    );
};

export default Shipments;
